import { Telemetry, ValidTelemetryEvent } from '~commonInfra/services/Telemetry';

// List of events. The event name will be what appears in the database.
export enum IntegrationsSettingsTelemetryEvents {
  PublishSalesforceBundle = 'publish_salesforce_bundle',
}

export enum IntegrationsSettingsTelemetryAction {
  clickPublishButton = 'publishButtonClick',
  clickCancelButton = 'cancelButtonClick',
  clickAddCredentialsMenuOption = 'addCredentialsMenuClick',
  clickExistingCredentialsMenuOption = 'existingCredentialsMenuClick',
  clickAddCredentialsButton = 'addCredentialsButtonClick',
}

export interface SalesforceIntegrationPublishButtonClickEvent extends ValidTelemetryEvent<SalesforceIntegrationPublishButtonClickEvent> {
  type: IntegrationsSettingsTelemetryEvents.PublishSalesforceBundle;
  action: IntegrationsSettingsTelemetryAction.clickPublishButton;
  bundles: string;
}

export function SalesforceIntegrationPublishButtonClickEvent(bundles: string[]) {
  Telemetry.sendEvent<SalesforceIntegrationPublishButtonClickEvent>({
    type: IntegrationsSettingsTelemetryEvents.PublishSalesforceBundle,
    action: IntegrationsSettingsTelemetryAction.clickPublishButton,
    bundles: JSON.stringify(bundles),
  });
}

export interface SalesforceIntegrationCancelButtonClickEvent extends ValidTelemetryEvent<SalesforceIntegrationCancelButtonClickEvent> {
  type: IntegrationsSettingsTelemetryEvents.PublishSalesforceBundle;
  action: IntegrationsSettingsTelemetryAction.clickCancelButton;
  bundles: string;
}

export function SalesforceIntegrationCancelButtonClickEvent(bundles: string[]) {
  Telemetry.sendEvent<SalesforceIntegrationCancelButtonClickEvent>({
    type: IntegrationsSettingsTelemetryEvents.PublishSalesforceBundle,
    action: IntegrationsSettingsTelemetryAction.clickCancelButton,
    bundles: JSON.stringify(bundles),
  });
}

export interface SalesforceIntegrationAddCredentialsMenuClickEvent extends ValidTelemetryEvent<SalesforceIntegrationAddCredentialsMenuClickEvent> {
  type: IntegrationsSettingsTelemetryEvents.PublishSalesforceBundle;
  action: IntegrationsSettingsTelemetryAction.clickAddCredentialsMenuOption;
}

export function SalesforceIntegrationAddCredentialsMenuClickEvent() {
  Telemetry.sendEvent<SalesforceIntegrationAddCredentialsMenuClickEvent>({
    type: IntegrationsSettingsTelemetryEvents.PublishSalesforceBundle,
    action: IntegrationsSettingsTelemetryAction.clickAddCredentialsMenuOption,
  });
}

export interface SalesforceIntegrationExistingCredentialsClickEvent extends ValidTelemetryEvent<SalesforceIntegrationExistingCredentialsClickEvent> {
  type: IntegrationsSettingsTelemetryEvents.PublishSalesforceBundle;
  action: IntegrationsSettingsTelemetryAction.clickExistingCredentialsMenuOption;
}

export function SalesforceIntegrationExistingCredentialsClickEvent() {
  Telemetry.sendEvent<SalesforceIntegrationExistingCredentialsClickEvent>({
    type: IntegrationsSettingsTelemetryEvents.PublishSalesforceBundle,
    action: IntegrationsSettingsTelemetryAction.clickExistingCredentialsMenuOption,
  });
}


export interface SalesforceIntegrationAddCredentialsButtonClickEvent extends ValidTelemetryEvent<SalesforceIntegrationAddCredentialsButtonClickEvent> {
  type: IntegrationsSettingsTelemetryEvents.PublishSalesforceBundle;
  action: IntegrationsSettingsTelemetryAction.clickAddCredentialsButton;

}

export function SalesforceIntegrationAddCredentialsButtonClickEvent() {
  Telemetry.sendEvent<SalesforceIntegrationAddCredentialsButtonClickEvent>({
    type: IntegrationsSettingsTelemetryEvents.PublishSalesforceBundle,
    action: IntegrationsSettingsTelemetryAction.clickAddCredentialsButton,
  });
}
